// Recovered compiled webpack factory 78617. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { E4: () => a, Hr: () => d, W9: () => u });
  var n = i(37899),
    s = i(40479),
    r = i(37822),
    o = i(92419);
  let a = (t) => t === r.ai || t === o.px,
    l = new Set(["x", "y", "z"]),
    h = s.U.filter((t) => !l.has(t));
  function u(t) {
    let e = [];
    return (
      h.forEach((i) => {
        let n = t.getValue(i);
        void 0 !== n && (e.push([i, n.get()]), n.set(+!!i.startsWith("scale")));
      }),
      e
    );
  }
  let d = {
    width: ({ x: t }, { paddingLeft: e = "0", paddingRight: i = "0", boxSizing: n }) => {
      let s = t.max - t.min;
      return "border-box" === n ? s : s - parseFloat(e) - parseFloat(i);
    },
    height: ({ y: t }, { paddingTop: e = "0", paddingBottom: i = "0", boxSizing: n }) => {
      let s = t.max - t.min;
      return "border-box" === n ? s : s - parseFloat(e) - parseFloat(i);
    },
    top: (t, { top: e }) => parseFloat(e),
    left: (t, { left: e }) => parseFloat(e),
    bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
    right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
    x: (t, { transform: e }) => (0, n.ry)(e, "x"),
    y: (t, { transform: e }) => (0, n.ry)(e, "y"),
  };
  ((d.translateX = d.x), (d.translateY = d.y));
}
